import { AppPathEnum } from '../../app/enums/appPathEnum';

export function parsePcsPaymentReturn(search: string, origin: string) {
  const params = new URLSearchParams(search);
  const code = params.get('Rc');
  const parts = params.get('ref')?.split('$$') || [];
  const path = parts[1]?.replace(/^retry-url=/, '');
  const validReference = Boolean(parts[0])
    && (path === AppPathEnum.PCS_ENROLMENT || path === AppPathEnum.PCS_RE_ENROLL);
  const retry = new URL(validReference ? path! : AppPathEnum.PCS_ENROLMENT, origin);
  if (validReference) retry.searchParams.set('ref', parts[0]);
  retry.searchParams.set('expectedStep', '4');
  // Preserve the existing non-C display convention; it is NOT backend confirmation.
  const outcome = !code || !validReference ? 'unknown' : code === 'C' ? 'cancelled' : 'success_screen';
  return { outcome, retryUrl: retry.toString() } as const;
}
